var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSnapshotExpandedView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 86,
    viewBox: "0 0 17 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2 80L10.2 76M14.2 80V76.8M14.2 80H11M2.19995 76.8V80M2.19995 80H5.39995M2.19995 80L6.19995 76M14.2 71.2V68M14.2 68H11M14.2 68L10.2 72M2.19995 71.2V68M2.19995 68H5.39995M2.19995 68L6.19995 72",
    stroke: "#212121",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnapshotExpandedView);
export default __webpack_public_path__ + "static/media/snapshotExpandedView.42c61ecc46552795b952bfc043fcbbcd.svg";
export { ForwardRef as ReactComponent };